import React, { useState, Fragment } from 'react'
import { Paper } from '@mui/material';
import { Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux'
import { useStateIfMounted } from 'use-state-if-mounted'
import { v4 as uuidv4 } from 'uuid';
import { host } from '../../../../configuraciones'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import {
    /*actualizarFC_36PaginaActivaAlmacen,
    agregarFC_36AnexoUnidadAlmacen,
    editarFC_36AnexoUnidadAlmacen,
    guardarCambiosFC_36AnexoUnidadAlmacen,
    registrarSolicitudFC_36Accion,
    agregarFC_36AnexoUnidadAlmacenMap,
    eliminarFC_36AnexoAlmacenMap,
    agregarFC_36AnexoUnidadAlmacenMapRevision,
    eliminarFC_36AnexoAlmacenMapRevision*/
} from '../../../../redux/DucksAtencionACliente/FC_36AtencionAClienteDucks'
import ToolBarPaginas from '../../../App/ToolBarPaginas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster)




import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import estilos from '../AtencionAClientesFC_36Component.module.css';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FC_36AnexoAlmacenComponent(props) {
    const dispatch = useDispatch()

    const mayor = '>'
    const menor = '<'
    var fechaHoy = moment().format('YYYY-MM-DD');

    let idEditable = 0
    if (props.history.location.state) {
        idEditable = props.history.location.state.idEdit
    }
    const anexoAlmacenEditable = useSelector(store => store.FC_36SolicitudAtencionACliente.anexoUnidadAlmacen).filter(anexo => anexo.data.id === idEditable)
    const anexoAlmacenFormato = useSelector(store => store.AtencionSolicitud.formato?.fc_36_anexounidaddealmacen)?.filter(anexo => anexo.id === idEditable)
    const anexoUnidadAlmacenMap = useSelector(store => store.FC_36SolicitudAtencionACliente.anexoUnidadAlmacenMap)
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const paginaActiva = useSelector(store => store.FC_36SolicitudAtencionACliente.paginaActivaAlmacen)
    const anexoUnidadAlmacenMapRevision = useSelector(store => store.FC_36SolicitudAtencionACliente.anexoUnidadAlmacenMapRevision)
    /*Datos FC_36 Anexo Unidad de Almacen*/
    const [nocliente, setnocliente] = useState()
    const [nombrerazonsocial, setnombrerazonsocialalmacen] = useStateIfMounted('')
    const [altainstalaciones, setaltainstalacionesalmacen] = useStateIfMounted(false)
    const [bajainstalaciones, setbajainstalacionesalmacen] = useStateIfMounted(false)
    const [fechasolicitud, setfechasolicitudalmacen] = useStateIfMounted(fechaHoy)
    const [fechapropuesta, setfechapropuestaalmacen] = useStateIfMounted(fechaHoy)
    const [instalacionnumero, setinstalacionnumeroalmacen] = useStateIfMounted(0)
    const [tipoinstalacionbodega, settipoinstalacionbodega] = useStateIfMounted(false)
    const [tipoinstalacionmaduracion, settipoinstalacionmaduracion] = useStateIfMounted(false)
    const [alias, setaliasalmacen] = useStateIfMounted('')
    const [calle, setcallealmacen] = useStateIfMounted('')
    const [numeroexterior, setnumeroexterioralmacen] = useStateIfMounted(0)
    const [numerointerior, setnumerointerioralmacen] = useStateIfMounted(0)
    const [colonia, setcoloniaalmacen] = useStateIfMounted('')
    const [localidad, setlocalidadalmacen] = useStateIfMounted('')
    const [municipio, setmunicipioalmacen] = useStateIfMounted('')
    const [estado, setestadoalmacen] = useStateIfMounted('')
    const [codigopostal, setcodigopostalalmacen] = useStateIfMounted('')
    const [referenciascercanas, setreferenciascercanasalmacen] = useStateIfMounted('')
    const [telefono, settelefonoalmacen] = useStateIfMounted('')
    const [correoelectronico, setcorreoelectronicoalmacen] = useStateIfMounted('')
    const [nombreresponsable, setnombreresponsablealmacen] = useStateIfMounted('')
    const [tarimas, settarimas] = useStateIfMounted(false)
    const [cantidadtarimas, setcantidadtarimas] = useStateIfMounted(0)
    const [capacidadtarimas, setcapacidadtarimas] = useStateIfMounted(0)
    const [patines, setpatines] = useStateIfMounted(false)
    const [cantidadpatines, setcantidadpatines] = useStateIfMounted(0)
    const [capacidadpatines, setcapacidadpatines] = useStateIfMounted(0)
    const [montacargas, setmontacargas] = useStateIfMounted(false)
    const [cantidadmontacargas, setcantidadmontacargas] = useStateIfMounted(0)
    const [capacidadmontacargas, setcapacidadmontacargas] = useStateIfMounted(0)
    const [se_alamientos, setse_alamientos] = useStateIfMounted(false)
    const [cantidadse_alamientos, setcantidadse_alamientos] = useStateIfMounted(0)
    const [capacidadse_alamientos, setcapacidadse_alamientos] = useStateIfMounted(0)
    const [otroproductoterminado, setotroproductoterminado] = useStateIfMounted(false)
    const [opcionproductoterminado, setopcionproductoterminado] = useStateIfMounted('')
    const [cantidadproductoterminado, setcantidadproductoterminado] = useStateIfMounted(0)
    const [capacidadproductoterminado, setcapacidadproductoterminado] = useStateIfMounted(0)
    const [recipientesvidrio, setrecipientesvidrio] = useStateIfMounted(false)
    const [cantidadrecipientesvidrio, setcantidadrecipientesvidrio] = useStateIfMounted(0)
    const [capacidadrecipientesvidrio, setcapacidadrecipientesvidrio] = useStateIfMounted(0)
    const [barricasmadera, setbarricasmadera] = useStateIfMounted(false)
    const [cantidadbarricasmadera, setcantidadbarricasmadera] = useStateIfMounted(0)
    const [capacidadbarricasmadera, setcapacidadbarricasmadera] = useStateIfMounted(0)
    const [controlhumedad, setcontrolhumedad] = useStateIfMounted(false)
    const [cantidadcontrolhumedad, setcantidadcontrolhumedad] = useStateIfMounted(0)
    const [caracteristicascontrolhumedad, setcaracteristicascontrolhumedad] = useStateIfMounted('')
    const [controltemperatura, setcontroltemperatura] = useStateIfMounted(false)
    const [cantidadcontroltemperatura, setcantidadcontroltemperatura] = useStateIfMounted(0)
    const [caracteristicascontroltemperatu, setcaracteristicascontroltemperatu] = useStateIfMounted('')
    const [otrocontrolvariables, setotrocontrolvariables] = useStateIfMounted(false)
    const [opcioncontrolvariables, setopcioncontrolvariables] = useStateIfMounted('')
    const [cantidadcontrolvariables, setcantidadcontrolvariables] = useStateIfMounted(0)
    const [caracteristicascontrolvariables, setcaracteristicascontrolvariables] = useStateIfMounted('')


    //variables para los checks de observacionews
    const [nombrerazonsocialcheck, setnombrerazonsocialcheck] = useStateIfMounted(false)
    const [altainstalacionescheck, setaltainstalacionescheck] = useStateIfMounted(false)
    const [bajainstalacionescheck, setbajainstalacionescheck] = useStateIfMounted(false)
    const [fechasolicitudcheck, setfechasolicitudcheck] = useStateIfMounted(false)
    const [fechapropuestacheck, setfechapropuestacheck] = useStateIfMounted(false)
    const [instalacionnumerocheck, setinstalacionnumerocheck] = useStateIfMounted(false)
    const [tipoinstalacionbodegacheck, settipoinstalacionbodegacheck] = useStateIfMounted(false)
    const [tipoinstalacionmaduracioncheck, settipoinstalacionmaduracioncheck] = useStateIfMounted(false)
    const [aliascheck, setaliascheck] = useStateIfMounted(false)
    const [callecheck, setcallecheck] = useStateIfMounted(false)
    const [numeroexteriorcheck, setnumeroexteriorcheck] = useStateIfMounted(false)
    const [numerointeriorcheck, setnumerointeriorcheck] = useStateIfMounted(false)
    const [coloniacheck, setcoloniacheck] = useStateIfMounted(false)
    const [localidadcheck, setlocalidadcheck] = useStateIfMounted(false)
    const [municipiocheck, setmunicipiocheck] = useStateIfMounted(false)
    const [estadocheck, setestadocheck] = useStateIfMounted(false)
    const [codigopostalcheck, setcodigopostalcheck] = useStateIfMounted(false)
    const [referenciascercanascheck, setreferenciascercanascheck] = useStateIfMounted(false)
    const [telefonocheck, settelefonocheck] = useStateIfMounted(false)
    const [correoelectronicocheck, setcorreoelectronicocheck] = useStateIfMounted(false)
    const [nombreresponsablecheck, setnombreresponsablecheck] = useStateIfMounted(false)
    const [tarimascheck, settarimascheck] = useStateIfMounted(false)
    const [cantidadtarimascheck, setcantidadtarimascheck] = useStateIfMounted(false)
    const [capacidadtarimascheck, setcapacidadtarimascheck] = useStateIfMounted(false)
    const [patinescheck, setpatinescheck] = useStateIfMounted(false)
    const [cantidadpatinescheck, setcantidadpatinescheck] = useStateIfMounted(false)
    const [capacidadpatinescheck, setcapacidadpatinescheck] = useStateIfMounted(false)
    const [montacargascheck, setmontacargascheck] = useStateIfMounted(false)
    const [cantidadmontacargascheck, setcantidadmontacargascheck] = useStateIfMounted(false)
    const [capacidadmontacargascheck, setcapacidadmontacargascheck] = useStateIfMounted(false)
    const [se_alamientoscheck, setse_alamientoscheck] = useStateIfMounted(false)
    const [cantidadse_alamientoscheck, setcantidadse_alamientoscheck] = useStateIfMounted(false)
    const [capacidadse_alamientoscheck, setcapacidadse_alamientoscheck] = useStateIfMounted(false)
    const [otroproductoterminadocheck, setotroproductoterminadocheck] = useStateIfMounted(false)
    const [opcionproductoterminadocheck, setopcionproductoterminadocheck] = useStateIfMounted(false)
    const [cantidadproductoterminadocheck, setcantidadproductoterminadocheck] = useStateIfMounted(false)
    const [capacidadproductoterminadocheck, setcapacidadproductoterminadocheck] = useStateIfMounted(false)
    const [recipientesvidriocheck, setrecipientesvidriocheck] = useStateIfMounted(false)
    const [cantidadrecipientesvidriocheck, setcantidadrecipientesvidriocheck] = useStateIfMounted(false)
    const [capacidadrecipientesvidriocheck, setcapacidadrecipientesvidriocheck] = useStateIfMounted(false)
    const [barricasmaderacheck, setbarricasmaderacheck] = useStateIfMounted(false)
    const [cantidadbarricasmaderacheck, setcantidadbarricasmaderacheck] = useStateIfMounted(false)
    const [capacidadbarricasmaderacheck, setcapacidadbarricasmaderacheck] = useStateIfMounted(false)
    const [controlhumedadcheck, setcontrolhumedadcheck] = useStateIfMounted(false)
    const [cantidadcontrolhumedadcheck, setcantidadcontrolhumedadcheck] = useStateIfMounted(false)
    const [caracteristicascontrolhumedadcheck, setcaracteristicascontrolhumedadcheck] = useStateIfMounted(false)
    const [controltemperaturacheck, setcontroltemperaturacheck] = useStateIfMounted(false)
    const [cantidadcontroltemperaturacheck, setcantidadcontroltemperaturacheck] = useStateIfMounted(false)
    const [caracteristicascontroltemperatucheck, setcaracteristicascontroltemperatucheck] = useStateIfMounted(false)
    const [otrocontrolvariablescheck, setotrocontrolvariablescheck] = useStateIfMounted(false)
    const [opcioncontrolvariablescheck, setopcioncontrolvariablescheck] = useStateIfMounted(false)
    const [cantidadcontrolvariablescheck, setcantidadcontrolvariablescheck] = useStateIfMounted(false)
    const [caracteristicascontrolvariablescheck, setcaracteristicascontrolvariablescheck] = useStateIfMounted(false)

    const [observaciones, setObservaciones] = useStateIfMounted({
        nombrerazonsocial: '', altainstalaciones: '', bajainstalaciones: '', fechasolicitud: '', fechapropuesta: '',
        instalacionnumero: '', tipoinstalacionbodega: '', tipoinstalacionmaduracion: '', alias: '', calle: '',
        numeroexterior: '', numerointerior: '', colonia: '', localidad: '', municipio: '', estado: '', codigopostal: '',
        referenciascercanas: '', telefono: '', correoelectronico: '', nombreresponsable: '', tarimas: '', cantidadtarimas: '',
        capacidadtarimas: '', patines: '', cantidadpatines: '', capacidadpatines: '', montacargas: '', cantidadmontacargas: '',
        capacidadmontacargas: '', se_alamientos: '', cantidadse_alamientos: '', capacidadse_alamientos: '',
        otroproductoterminado: '', opcionproductoterminado: '', cantidadproductoterminado: '', capacidadproductoterminado: '',
        recipientesvidrio: '', cantidadrecipientesvidrio: '', capacidadrecipientesvidrio: '', barricasmadera: '',
        cantidadbarricasmadera: '', capacidadbarricasmadera: '', controlhumedad: '', cantidadcontrolhumedad: '',
        caracteristicascontrolhumedad: '', controltemperatura: '', cantidadcontroltemperatura: '',
        caracteristicascontroltemperatu: '', otrocontrolvariables: '', opcioncontrolvariables: '',
        cantidadcontrolvariables: '', caracteristicascontrolvariables: ''
    });
    //metodos de actualizacion
    const checknombrerazonsocialcheck = () => {
        if (!nombrerazonsocialcheck) {
            setnombrerazonsocialcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('nombrerazonsocial')
        } else {
            setnombrerazonsocialcheck(false)
            observaciones['nombrerazonsocial'] = ''
        }
    }
    const checkaltainstalacionescheck = () => {
        if (!altainstalacionescheck) {
            setaltainstalacionescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('altainstalaciones')
        } else {
            setaltainstalacionescheck(false)
            observaciones['altainstalaciones'] = ''
        }
    }
    const checkbajainstalacionescheck = () => {
        if (!bajainstalacionescheck) {
            setbajainstalacionescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('bajainstalaciones')
        } else {
            setbajainstalacionescheck(false)
            observaciones['bajainstalaciones'] = ''
        }
    }
    const checkfechasolicitudcheck = () => {
        if (!fechasolicitudcheck) {
            setfechasolicitudcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('fechasolicitud')
        } else {
            setfechasolicitudcheck(false)
            observaciones['fechasolicitud'] = ''
        }
    }
    const checkfechapropuestacheck = () => {
        if (!fechapropuestacheck) {
            setfechapropuestacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('fechapropuesta')
        } else {
            setfechapropuestacheck(false)
            observaciones['fechapropuesta'] = ''
        }
    }
    const checkinstalacionnumerocheck = () => {
        if (!instalacionnumerocheck) {
            setinstalacionnumerocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('instalacionnumero')
        } else {
            setinstalacionnumerocheck(false)
            observaciones['instalacionnumero'] = ''
        }
    }
    const checktipoinstalacionbodegacheck = () => {
        if (!tipoinstalacionbodegacheck) {
            settipoinstalacionbodegacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('tipoinstalacionbodega')
        } else {
            settipoinstalacionbodegacheck(false)
            observaciones['tipoinstalacionbodega'] = ''
        }
    }
    const checktipoinstalacionmaduracioncheck = () => {
        if (!tipoinstalacionmaduracioncheck) {
            settipoinstalacionmaduracioncheck(true)
            handleOpenModalObservaciones()
            mostrarModal('tipoinstalacionmaduracion')
        } else {
            settipoinstalacionmaduracioncheck(false)
            observaciones['tipoinstalacionmaduracion'] = ''
        }
    }
    const checkaliascheck = () => {
        if (!aliascheck) {
            setaliascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('alias')
        } else {
            setaliascheck(false)
            observaciones['alias'] = ''
        }
    }
    const checkcallecheck = () => {
        if (!callecheck) {
            setcallecheck(true)
            handleOpenModalObservaciones()
            mostrarModal('calle')
        } else {
            setcallecheck(false)
            observaciones['calle'] = ''
        }
    }
    const checknumeroexteriorcheck = () => {
        if (!numeroexteriorcheck) {
            setnumeroexteriorcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('numeroexterior')
        } else {
            setnumeroexteriorcheck(false)
            observaciones['numeroexterior'] = ''
        }
    }
    const checknumerointeriorcheck = () => {
        if (!numerointeriorcheck) {
            setnumerointeriorcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('numerointerior')
        } else {
            setnumerointeriorcheck(false)
            observaciones['numerointerior'] = ''
        }
    }
    const checkcoloniacheck = () => {
        if (!coloniacheck) {
            setcoloniacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('colonia')
        } else {
            setcoloniacheck(false)
            observaciones['colonia'] = ''
        }
    }
    const checklocalidadcheck = () => {
        if (!localidadcheck) {
            setlocalidadcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('localidad')
        } else {
            setlocalidadcheck(false)
            observaciones['localidad'] = ''
        }
    }
    const checkmunicipiocheck = () => {
        if (!municipiocheck) {
            setmunicipiocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('municipio')
        } else {
            setmunicipiocheck(false)
            observaciones['municipio'] = ''
        }
    }
    const checkestadocheck = () => {
        if (!estadocheck) {
            setestadocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('estado')
        } else {
            setestadocheck(false)
            observaciones['estado'] = ''
        }
    }
    const checkcodigopostalcheck = () => {
        if (!codigopostalcheck) {
            setcodigopostalcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('codigopostal')
        } else {
            setcodigopostalcheck(false)
            observaciones['codigopostal'] = ''
        }
    }
    const checkreferenciascercanascheck = () => {
        if (!referenciascercanascheck) {
            setreferenciascercanascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('referenciascercanas')
        } else {
            setreferenciascercanascheck(false)
            observaciones['referenciascercanas'] = ''
        }
    }
    const checktelefonocheck = () => {
        if (!telefonocheck) {
            settelefonocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('telefono')
        } else {
            settelefonocheck(false)
            observaciones['telefono'] = ''
        }
    }
    const checkcorreoelectronicocheck = () => {
        if (!correoelectronicocheck) {
            setcorreoelectronicocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('correoelectronico')
        } else {
            setcorreoelectronicocheck(false)
            observaciones['correoelectronico'] = ''
        }
    }
    const checknombreresponsablecheck = () => {
        if (!nombreresponsablecheck) {
            setnombreresponsablecheck(true)
            handleOpenModalObservaciones()
            mostrarModal('nombreresponsable')
        } else {
            setnombreresponsablecheck(false)
            observaciones['nombreresponsable'] = ''
        }
    }
    const checktarimascheck = () => {
        if (!tarimascheck) {
            settarimascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('tarimas')
        } else {
            settarimascheck(false)
            observaciones['tarimas'] = ''
        }
    }
    const checkcantidadtarimascheck = () => {
        if (!cantidadtarimascheck) {
            setcantidadtarimascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadtarimas')
        } else {
            setcantidadtarimascheck(false)
            observaciones['cantidadtarimas'] = ''
        }
    }
    const checkcapacidadtarimascheck = () => {
        if (!capacidadtarimascheck) {
            setcapacidadtarimascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadtarimas')
        } else {
            setcapacidadtarimascheck(false)
            observaciones['capacidadtarimas'] = ''
        }
    }
    const checkpatinescheck = () => {
        if (!patinescheck) {
            setpatinescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('patines')
        } else {
            setpatinescheck(false)
            observaciones['patines'] = ''
        }
    }
    const checkcantidadpatinescheck = () => {
        if (!cantidadpatinescheck) {
            setcantidadpatinescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadpatines')
        } else {
            setcantidadpatinescheck(false)
            observaciones['cantidadpatines'] = ''
        }
    }
    const checkcapacidadpatinescheck = () => {
        if (!capacidadpatinescheck) {
            setcapacidadpatinescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadpatines')
        } else {
            setcapacidadpatinescheck(false)
            observaciones['capacidadpatines'] = ''
        }
    }
    const checkmontacargascheck = () => {
        if (!montacargascheck) {
            setmontacargascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('montacargas')
        } else {
            setmontacargascheck(false)
            observaciones['montacargas'] = ''
        }
    }
    const checkcantidadmontacargascheck = () => {
        if (!cantidadmontacargascheck) {
            setcantidadmontacargascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadmontacargas')
        } else {
            setcantidadmontacargascheck(false)
            observaciones['cantidadmontacargas'] = ''
        }
    }
    const checkcapacidadmontacargascheck = () => {
        if (!capacidadmontacargascheck) {
            setcapacidadmontacargascheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadmontacargas')
        } else {
            setcapacidadmontacargascheck(false)
            observaciones['capacidadmontacargas'] = ''
        }
    }
    const checkse_alamientoscheck = () => {
        if (!se_alamientoscheck) {
            setse_alamientoscheck(true)
            handleOpenModalObservaciones()
            mostrarModal('se_alamientos')
        } else {
            setse_alamientoscheck(false)
            observaciones['se_alamientos'] = ''
        }
    }
    const checkcantidadse_alamientoscheck = () => {
        if (!cantidadse_alamientoscheck) {
            setcantidadse_alamientoscheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadse_alamientos')
        } else {
            setcantidadse_alamientoscheck(false)
            observaciones['cantidadse_alamientos'] = ''
        }
    }
    const checkcapacidadse_alamientoscheck = () => {
        if (!capacidadse_alamientoscheck) {
            setcapacidadse_alamientoscheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadse_alamientos')
        } else {
            setcapacidadse_alamientoscheck(false)
            observaciones['capacidadse_alamientos'] = ''
        }
    }
    const checkotroproductoterminadocheck = () => {
        if (!otroproductoterminadocheck) {
            setotroproductoterminadocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otroproductoterminado')
        } else {
            setotroproductoterminadocheck(false)
            observaciones['otroproductoterminado'] = ''
        }
    }
    const checkopcionproductoterminadocheck = () => {
        if (!opcionproductoterminadocheck) {
            setopcionproductoterminadocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcionproductoterminado')
        } else {
            setopcionproductoterminadocheck(false)
            observaciones['opcionproductoterminado'] = ''
        }
    }
    const checkcantidadproductoterminadocheck = () => {
        if (!cantidadproductoterminadocheck) {
            setcantidadproductoterminadocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadproductoterminado')
        } else {
            setcantidadproductoterminadocheck(false)
            observaciones['cantidadproductoterminado'] = ''
        }
    }
    const checkcapacidadproductoterminadocheck = () => {
        if (!capacidadproductoterminadocheck) {
            setcapacidadproductoterminadocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadproductoterminado')
        } else {
            setcapacidadproductoterminadocheck(false)
            observaciones['capacidadproductoterminado'] = ''
        }
    }
    const checkrecipientesvidriocheck = () => {
        if (!recipientesvidriocheck) {
            setrecipientesvidriocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('recipientesvidrio')
        } else {
            setrecipientesvidriocheck(false)
            observaciones['recipientesvidrio'] = ''
        }
    }
    const checkcantidadrecipientesvidriocheck = () => {
        if (!cantidadrecipientesvidriocheck) {
            setcantidadrecipientesvidriocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadrecipientesvidrio')
        } else {
            setcantidadrecipientesvidriocheck(false)
            observaciones['cantidadrecipientesvidrio'] = ''
        }
    }
    const checkcapacidadrecipientesvidriocheck = () => {
        if (!capacidadrecipientesvidriocheck) {
            setcapacidadrecipientesvidriocheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadrecipientesvidrio')
        } else {
            setcapacidadrecipientesvidriocheck(false)
            observaciones['capacidadrecipientesvidrio'] = ''
        }
    }
    const checkbarricasmaderacheck = () => {
        if (!barricasmaderacheck) {
            setbarricasmaderacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('barricasmadera')
        } else {
            setbarricasmaderacheck(false)
            observaciones['barricasmadera'] = ''
        }
    }
    const checkcantidadbarricasmaderacheck = () => {
        if (!cantidadbarricasmaderacheck) {
            setcantidadbarricasmaderacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadbarricasmadera')
        } else {
            setcantidadbarricasmaderacheck(false)
            observaciones['cantidadbarricasmadera'] = ''
        }
    }
    const checkcapacidadbarricasmaderacheck = () => {
        if (!capacidadbarricasmaderacheck) {
            setcapacidadbarricasmaderacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('capacidadbarricasmadera')
        } else {
            setcapacidadbarricasmaderacheck(false)
            observaciones['capacidadbarricasmadera'] = ''
        }
    }
    const checkcontrolhumedadcheck = () => {
        if (!controlhumedadcheck) {
            setcontrolhumedadcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('controlhumedad')
        } else {
            setcontrolhumedadcheck(false)
            observaciones['controlhumedad'] = ''
        }
    }
    const checkcantidadcontrolhumedadcheck = () => {
        if (!cantidadcontrolhumedadcheck) {
            setcantidadcontrolhumedadcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadcontrolhumedad')
        } else {
            setcantidadcontrolhumedadcheck(false)
            observaciones['cantidadcontrolhumedad'] = ''
        }
    }
    const checkcaracteristicascontrolhumedadcheck = () => {
        if (!caracteristicascontrolhumedadcheck) {
            setcaracteristicascontrolhumedadcheck(true)
            handleOpenModalObservaciones()
            mostrarModal('caracteristicascontrolhumedad')
        } else {
            setcaracteristicascontrolhumedadcheck(false)
            observaciones['caracteristicascontrolhumedad'] = ''
        }
    }
    const checkcontroltemperaturacheck = () => {
        if (!controltemperaturacheck) {
            setcontroltemperaturacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('controltemperatura')
        } else {
            setcontroltemperaturacheck(false)
            observaciones['controltemperatura'] = ''
        }
    }
    const checkcantidadcontroltemperaturacheck = () => {
        if (!cantidadcontroltemperaturacheck) {
            setcantidadcontroltemperaturacheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadcontroltemperatura')
        } else {
            setcantidadcontroltemperaturacheck(false)
            observaciones['cantidadcontroltemperatura'] = ''
        }
    }
    const checkcaracteristicascontroltemperatucheck = () => {
        if (!caracteristicascontroltemperatucheck) {
            setcaracteristicascontroltemperatucheck(true)
            handleOpenModalObservaciones()
            mostrarModal('caracteristicascontroltemperatu')
        } else {
            setcaracteristicascontroltemperatucheck(false)
            observaciones['caracteristicascontroltemperatu'] = ''
        }
    }
    const checkotrocontrolvariablescheck = () => {
        if (!otrocontrolvariablescheck) {
            setotrocontrolvariablescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('otrocontrolvariables')
        } else {
            setotrocontrolvariablescheck(false)
            observaciones['otrocontrolvariables'] = ''
        }
    }
    const checkopcioncontrolvariablescheck = () => {
        if (!opcioncontrolvariablescheck) {
            setopcioncontrolvariablescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('opcioncontrolvariables')
        } else {
            setopcioncontrolvariablescheck(false)
            observaciones['opcioncontrolvariables'] = ''
        }
    }
    const checkcantidadcontrolvariablescheck = () => {
        if (!cantidadcontrolvariablescheck) {
            setcantidadcontrolvariablescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('cantidadcontrolvariables')
        } else {
            setcantidadcontrolvariablescheck(false)
            observaciones['cantidadcontrolvariables'] = ''
        }
    }
    const checkcaracteristicascontrolvariablescheck = () => {
        if (!caracteristicascontrolvariablescheck) {
            setcaracteristicascontrolvariablescheck(true)
            handleOpenModalObservaciones()
            mostrarModal('caracteristicascontrolvariables')
        } else {
            setcaracteristicascontrolvariablescheck(false)
            observaciones['caracteristicascontrolvariables'] = ''
        }
    }

    //metodos de formato principal
    const setAccionInstalacion = (target) => {
        if (target.id === 'alta') {
            if (target.checked) {
                setaltainstalacionesalmacen(true)
                setbajainstalacionesalmacen(false)
            }

        } else if (target.id === 'baja') {
            if (target.checked) {
                setbajainstalacionesalmacen(true)
                setaltainstalacionesalmacen(false)
            }
        }
    }

    React.useEffect(() => {
        if (anexoAlmacenFormato.length > 0) {
            setnocliente(anexoAlmacenFormato[0].nocliente)
            setnombrerazonsocialalmacen(anexoAlmacenFormato[0].nombrerazonsocial)
            setaltainstalacionesalmacen(anexoAlmacenFormato[0].altainstalaciones)
            setbajainstalacionesalmacen(anexoAlmacenFormato[0].bajainstalaciones)
            setfechasolicitudalmacen(anexoAlmacenFormato[0].fechasolicitud)
            setfechapropuestaalmacen(anexoAlmacenFormato[0].fechapropuesta)
            setinstalacionnumeroalmacen(anexoAlmacenFormato[0].instalacionnumero)
            settipoinstalacionbodega(anexoAlmacenFormato[0].tipoinstalacionbodega)
            settipoinstalacionmaduracion(anexoAlmacenFormato[0].tipoinstalacionmaduracion)
            setaliasalmacen(anexoAlmacenFormato[0].alias)
            setcallealmacen(anexoAlmacenFormato[0].calle)
            setnumeroexterioralmacen(anexoAlmacenFormato[0].numeroexterior)
            setnumerointerioralmacen(anexoAlmacenFormato[0].numerointerior)
            setcoloniaalmacen(anexoAlmacenFormato[0].colonia)
            setlocalidadalmacen(anexoAlmacenFormato[0].localidad)
            setmunicipioalmacen(anexoAlmacenFormato[0].municipio)
            setestadoalmacen(anexoAlmacenFormato[0].estado)
            setcodigopostalalmacen(anexoAlmacenFormato[0].codigopostal)
            setreferenciascercanasalmacen(anexoAlmacenFormato[0].referenciascercanas)
            settelefonoalmacen(anexoAlmacenFormato[0].telefono)
            setcorreoelectronicoalmacen(anexoAlmacenFormato[0].correoelectronico)
            setnombreresponsablealmacen(anexoAlmacenFormato[0].nombreresponsable)
            settarimas(anexoAlmacenFormato[0].tarimas)
            setcantidadtarimas(anexoAlmacenFormato[0].cantidadtarimas)
            setcapacidadtarimas(anexoAlmacenFormato[0].capacidadtarimas)
            setpatines(anexoAlmacenFormato[0].patines)
            setcantidadpatines(anexoAlmacenFormato[0].cantidadpatines)
            setcapacidadpatines(anexoAlmacenFormato[0].capacidadpatines)
            setmontacargas(anexoAlmacenFormato[0].montacargas)
            setcantidadmontacargas(anexoAlmacenFormato[0].cantidadmontacargas)
            setcapacidadmontacargas(anexoAlmacenFormato[0].capacidadmontacargas)
            setse_alamientos(anexoAlmacenFormato[0].se_alamientos)
            setcantidadse_alamientos(anexoAlmacenFormato[0].cantidadse_alamientos)
            setcapacidadse_alamientos(anexoAlmacenFormato[0].capacidadse_alamientos)
            setotroproductoterminado(anexoAlmacenFormato[0].otroproductoterminado)
            setopcionproductoterminado(anexoAlmacenFormato[0].opcionproductoterminado)
            setcantidadproductoterminado(anexoAlmacenFormato[0].cantidadproductoterminado)
            setcapacidadproductoterminado(anexoAlmacenFormato[0].capacidadproductoterminado)
            setrecipientesvidrio(anexoAlmacenFormato[0].recipientesvidrio)
            setcantidadrecipientesvidrio(anexoAlmacenFormato[0].cantidadrecipientesvidrio)
            setcapacidadrecipientesvidrio(anexoAlmacenFormato[0].capacidadrecipientesvidrio)
            setbarricasmadera(anexoAlmacenFormato[0].barricasmadera)
            setcantidadbarricasmadera(anexoAlmacenFormato[0].cantidadbarricasmadera)
            setcapacidadbarricasmadera(anexoAlmacenFormato[0].capacidadbarricasmadera)
            setcontrolhumedad(anexoAlmacenFormato[0].controlhumedad)
            setcantidadcontrolhumedad(anexoAlmacenFormato[0].cantidadcontrolhumedad)
            setcaracteristicascontrolhumedad(anexoAlmacenFormato[0].caracteristicascontrolhumedad)
            setcontroltemperatura(anexoAlmacenFormato[0].controltemperatura)
            setcantidadcontroltemperatura(anexoAlmacenFormato[0].cantidadcontroltemperatura)
            setcaracteristicascontroltemperatu(anexoAlmacenFormato[0].caracteristicascontroltemperatu)
            setotrocontrolvariables(anexoAlmacenFormato[0].otrocontrolvariables)
            setopcioncontrolvariables(anexoAlmacenFormato[0].opcioncontrolvariables)
            setcantidadcontrolvariables(anexoAlmacenFormato[0].cantidadcontrolvariables)
            setcaracteristicascontrolvariables(anexoAlmacenFormato[0].caracteristicascontrolvariables)

        }
    }, [])
    React.useEffect(() => {
        if (!(JSON.stringify([]) === JSON.stringify(anexoUnidadAlmacenMap))) {
            setnombrerazonsocialcheck(anexoUnidadAlmacenMap.nombrerazonsocialcheck)
            setaltainstalacionescheck(anexoUnidadAlmacenMap.altainstalacionescheck)
            setbajainstalacionescheck(anexoUnidadAlmacenMap.bajainstalacionescheck)
            setfechasolicitudcheck(anexoUnidadAlmacenMap.fechasolicitudcheck)
            setfechapropuestacheck(anexoUnidadAlmacenMap.fechapropuestacheck)
            setinstalacionnumerocheck(anexoUnidadAlmacenMap.instalacionnumerocheck)
            settipoinstalacionbodegacheck(anexoUnidadAlmacenMap.tipoinstalacionbodegacheck)
            settipoinstalacionmaduracioncheck(anexoUnidadAlmacenMap.tipoinstalacionmaduracioncheck)
            setaliascheck(anexoUnidadAlmacenMap.aliascheck)
            setcallecheck(anexoUnidadAlmacenMap.callecheck)
            setnumeroexteriorcheck(anexoUnidadAlmacenMap.numeroexteriorcheck)
            setnumerointeriorcheck(anexoUnidadAlmacenMap.numerointeriorcheck)
            setcoloniacheck(anexoUnidadAlmacenMap.coloniacheck)
            setlocalidadcheck(anexoUnidadAlmacenMap.localidadcheck)
            setmunicipiocheck(anexoUnidadAlmacenMap.municipiocheck)
            setestadocheck(anexoUnidadAlmacenMap.estadocheck)
            setcodigopostalcheck(anexoUnidadAlmacenMap.codigopostalcheck)
            setreferenciascercanascheck(anexoUnidadAlmacenMap.referenciascercanascheck)
            settelefonocheck(anexoUnidadAlmacenMap.telefonocheck)
            setcorreoelectronicocheck(anexoUnidadAlmacenMap.correoelectronicocheck)
            setnombreresponsablecheck(anexoUnidadAlmacenMap.nombreresponsablecheck)
            settarimascheck(anexoUnidadAlmacenMap.tarimascheck)
            setcantidadtarimascheck(anexoUnidadAlmacenMap.cantidadtarimascheck)
            setcapacidadtarimascheck(anexoUnidadAlmacenMap.capacidadtarimascheck)
            setpatinescheck(anexoUnidadAlmacenMap.patinescheck)
            setcantidadpatinescheck(anexoUnidadAlmacenMap.cantidadpatinescheck)
            setcapacidadpatinescheck(anexoUnidadAlmacenMap.capacidadpatinescheck)
            setmontacargascheck(anexoUnidadAlmacenMap.montacargascheck)
            setcantidadmontacargascheck(anexoUnidadAlmacenMap.cantidadmontacargascheck)
            setcapacidadmontacargascheck(anexoUnidadAlmacenMap.capacidadmontacargascheck)
            setse_alamientoscheck(anexoUnidadAlmacenMap.se_alamientoscheck)
            setcantidadse_alamientoscheck(anexoUnidadAlmacenMap.cantidadse_alamientoscheck)
            setcapacidadse_alamientoscheck(anexoUnidadAlmacenMap.capacidadse_alamientoscheck)
            setotroproductoterminadocheck(anexoUnidadAlmacenMap.otroproductoterminadocheck)
            setopcionproductoterminadocheck(anexoUnidadAlmacenMap.opcionproductoterminadocheck)
            setcantidadproductoterminadocheck(anexoUnidadAlmacenMap.cantidadproductoterminadocheck)
            setcapacidadproductoterminadocheck(anexoUnidadAlmacenMap.capacidadproductoterminadocheck)
            setrecipientesvidriocheck(anexoUnidadAlmacenMap.recipientesvidriocheck)
            setcantidadrecipientesvidriocheck(anexoUnidadAlmacenMap.cantidadrecipientesvidriocheck)
            setcapacidadrecipientesvidriocheck(anexoUnidadAlmacenMap.capacidadrecipientesvidriocheck)
            setbarricasmaderacheck(anexoUnidadAlmacenMap.barricasmaderacheck)
            setcantidadbarricasmaderacheck(anexoUnidadAlmacenMap.cantidadbarricasmaderacheck)
            setcapacidadbarricasmaderacheck(anexoUnidadAlmacenMap.capacidadbarricasmaderacheck)
            setcontrolhumedadcheck(anexoUnidadAlmacenMap.controlhumedadcheck)
            setcantidadcontrolhumedadcheck(anexoUnidadAlmacenMap.cantidadcontrolhumedadcheck)
            setcaracteristicascontrolhumedadcheck(anexoUnidadAlmacenMap.caracteristicascontrolhumedadcheck)
            setcontroltemperaturacheck(anexoUnidadAlmacenMap.controltemperaturacheck)
            setcantidadcontroltemperaturacheck(anexoUnidadAlmacenMap.cantidadcontroltemperaturacheck)
            setcaracteristicascontroltemperatucheck(anexoUnidadAlmacenMap.caracteristicascontroltemperatucheck)
            setotrocontrolvariablescheck(anexoUnidadAlmacenMap.otrocontrolvariablescheck)
            setopcioncontrolvariablescheck(anexoUnidadAlmacenMap.opcioncontrolvariablescheck)
            setcantidadcontrolvariablescheck(anexoUnidadAlmacenMap.cantidadcontrolvariablescheck)
            setcaracteristicascontrolvariablescheck(anexoUnidadAlmacenMap.caracteristicascontrolvariablescheck)
            observaciones.nombrerazonsocial = anexoUnidadAlmacenMap.nombrerazonsocial
            observaciones.altainstalaciones = anexoUnidadAlmacenMap.altainstalaciones
            observaciones.bajainstalaciones = anexoUnidadAlmacenMap.bajainstalaciones
            observaciones.fechasolicitud = anexoUnidadAlmacenMap.fechasolicitud
            observaciones.fechapropuesta = anexoUnidadAlmacenMap.fechapropuesta
            observaciones.instalacionnumero = anexoUnidadAlmacenMap.instalacionnumero
            observaciones.tipoinstalacionbodega = anexoUnidadAlmacenMap.tipoinstalacionbodega
            observaciones.tipoinstalacionmaduracion = anexoUnidadAlmacenMap.tipoinstalacionmaduracion
            observaciones.alias = anexoUnidadAlmacenMap.alias
            observaciones.calle = anexoUnidadAlmacenMap.calle
            observaciones.numeroexterior = anexoUnidadAlmacenMap.numeroexterior
            observaciones.numerointerior = anexoUnidadAlmacenMap.numerointerior
            observaciones.colonia = anexoUnidadAlmacenMap.colonia
            observaciones.localidad = anexoUnidadAlmacenMap.localidad
            observaciones.municipio = anexoUnidadAlmacenMap.municipio
            observaciones.estado = anexoUnidadAlmacenMap.estado
            observaciones.codigopostal = anexoUnidadAlmacenMap.codigopostal
            observaciones.referenciascercanas = anexoUnidadAlmacenMap.referenciascercanas
            observaciones.telefono = anexoUnidadAlmacenMap.telefono
            observaciones.correoelectronico = anexoUnidadAlmacenMap.correoelectronico
            observaciones.nombreresponsable = anexoUnidadAlmacenMap.nombreresponsable
            observaciones.tarimas = anexoUnidadAlmacenMap.tarimas
            observaciones.cantidadtarimas = anexoUnidadAlmacenMap.cantidadtarimas
            observaciones.capacidadtarimas = anexoUnidadAlmacenMap.capacidadtarimas
            observaciones.patines = anexoUnidadAlmacenMap.patines
            observaciones.cantidadpatines = anexoUnidadAlmacenMap.cantidadpatines
            observaciones.capacidadpatines = anexoUnidadAlmacenMap.capacidadpatines
            observaciones.montacargas = anexoUnidadAlmacenMap.montacargas
            observaciones.cantidadmontacargas = anexoUnidadAlmacenMap.cantidadmontacargas
            observaciones.capacidadmontacargas = anexoUnidadAlmacenMap.capacidadmontacargas
            observaciones.se_alamientos = anexoUnidadAlmacenMap.se_alamientos
            observaciones.cantidadse_alamientos = anexoUnidadAlmacenMap.cantidadse_alamientos
            observaciones.capacidadse_alamientos = anexoUnidadAlmacenMap.capacidadse_alamientos
            observaciones.otroproductoterminado = anexoUnidadAlmacenMap.otroproductoterminado
            observaciones.opcionproductoterminado = anexoUnidadAlmacenMap.opcionproductoterminado
            observaciones.cantidadproductoterminado = anexoUnidadAlmacenMap.cantidadproductoterminado
            observaciones.capacidadproductoterminado = anexoUnidadAlmacenMap.capacidadproductoterminado
            observaciones.recipientesvidrio = anexoUnidadAlmacenMap.recipientesvidrio
            observaciones.cantidadrecipientesvidrio = anexoUnidadAlmacenMap.cantidadrecipientesvidrio
            observaciones.capacidadrecipientesvidrio = anexoUnidadAlmacenMap.capacidadrecipientesvidrio
            observaciones.barricasmadera = anexoUnidadAlmacenMap.barricasmadera
            observaciones.cantidadbarricasmadera = anexoUnidadAlmacenMap.cantidadbarricasmadera
            observaciones.capacidadbarricasmadera = anexoUnidadAlmacenMap.capacidadbarricasmadera
            observaciones.controlhumedad = anexoUnidadAlmacenMap.controlhumedad
            observaciones.cantidadcontrolhumedad = anexoUnidadAlmacenMap.cantidadcontrolhumedad
            observaciones.caracteristicascontrolhumedad = anexoUnidadAlmacenMap.caracteristicascontrolhumedad
            observaciones.controltemperatura = anexoUnidadAlmacenMap.controltemperatura
            observaciones.cantidadcontroltemperatura = anexoUnidadAlmacenMap.cantidadcontroltemperatura
            observaciones.caracteristicascontroltemperatu = anexoUnidadAlmacenMap.caracteristicascontroltemperatu
            observaciones.otrocontrolvariables = anexoUnidadAlmacenMap.otrocontrolvariables
            observaciones.opcioncontrolvariables = anexoUnidadAlmacenMap.opcioncontrolvariables
            observaciones.cantidadcontrolvariables = anexoUnidadAlmacenMap.cantidadcontrolvariables
            observaciones.caracteristicascontrolvariables = anexoUnidadAlmacenMap.caracteristicascontrolvariables
        }
    }, [])
    const botonEditarAnexoAlmacen = async () => {
        await dispatch(editarFC_36AnexoUnidadAlmacen({
            id: idEditable,
            nocliente, nombrerazonsocial, altainstalaciones, bajainstalaciones,
            fechasolicitud, fechapropuesta, instalacionnumero, tipoinstalacionbodega,
            tipoinstalacionmaduracion, alias, calle, numeroexterior,
            numerointerior, colonia, localidad, municipio, estado,
            codigopostal, referenciascercanas, telefono, correoelectronico,
            nombreresponsable, tarimas, cantidadtarimas, capacidadtarimas, patines, cantidadpatines,
            capacidadpatines, montacargas, cantidadmontacargas, capacidadmontacargas, se_alamientos,
            cantidadse_alamientos, capacidadse_alamientos, otroproductoterminado, opcionproductoterminado,
            cantidadproductoterminado, capacidadproductoterminado, recipientesvidrio,
            cantidadrecipientesvidrio, capacidadrecipientesvidrio, barricasmadera, cantidadbarricasmadera,
            capacidadbarricasmadera, controlhumedad, cantidadcontrolhumedad, caracteristicascontrolhumedad,
            controltemperatura, cantidadcontroltemperatura, caracteristicascontroltemperatu,
            otrocontrolvariables, opcioncontrolvariables, cantidadcontrolvariables,
            caracteristicascontrolvariables
        }))
        //await dispatch(actualizarFC_36PaginaActivaAlmacen(1))
        props.history.push('/fc_36')
    }
    const botonRegistrarAnexoAlmacen = async () => {
        const res = await dispatch(agregarFC_36AnexoUnidadAlmacen({
            id: uuidv4(),
            nocliente, nombrerazonsocial, altainstalaciones, bajainstalaciones,
            fechasolicitud, fechapropuesta, instalacionnumero, tipoinstalacionbodega,
            tipoinstalacionmaduracion, alias, calle, numeroexterior,
            numerointerior, colonia, localidad, municipio, estado,
            codigopostal, referenciascercanas, telefono, correoelectronico,
            nombreresponsable, tarimas, cantidadtarimas, capacidadtarimas, patines, cantidadpatines,
            capacidadpatines, montacargas, cantidadmontacargas, capacidadmontacargas, se_alamientos,
            cantidadse_alamientos, capacidadse_alamientos, otroproductoterminado, opcionproductoterminado,
            cantidadproductoterminado, capacidadproductoterminado, recipientesvidrio,
            cantidadrecipientesvidrio, capacidadrecipientesvidrio, barricasmadera, cantidadbarricasmadera,
            capacidadbarricasmadera, controlhumedad, cantidadcontrolhumedad, caracteristicascontrolhumedad,
            controltemperatura, cantidadcontroltemperatura, caracteristicascontroltemperatu,
            otrocontrolvariables, opcioncontrolvariables, cantidadcontrolvariables,
            caracteristicascontrolvariables
        }))
        //await dispatch(actualizarFC_36PaginaActivaAlmacen(1))
        props.history.push('/fc_36')
    }
    const botonRegresarFC_36 = async () => {
        //await dispatch(actualizarFC_36PaginaActivaAlmacen(1))
        props.history.push('/fc_36')
    }

    /*const botonGuardarCambiosFC_36AnexoUnidadAlmacen = async (accion) => {
        console.log('Guardando cambios fc_36AnexoUnidadAlmacen')
        await dispatch(guardarCambiosFC_36AnexoUnidadAlmacen({
            nombrerazonsocial, altainstalaciones, bajainstalaciones,
            fechasolicitud, fechapropuesta, instalacionnumero, tipoinstalacionbodega,
            tipoinstalacionmaduracion, alias, calle, numeroexterior,
            numerointerior, colonia, localidad, municipio, estado,
            codigopostal, referenciascercanas, telefono, correoelectronico,
            nombreresponsable, tarimas, cantidadtarimas, capacidadtarimas, patines, cantidadpatines,
            capacidadpatines, montacargas, cantidadmontacargas, capacidadmontacargas, se_alamientos,
            cantidadse_alamientos, capacidadse_alamientos, otroproductoterminado, opcionproductoterminado,
            cantidadproductoterminado, capacidadproductoterminado, recipientesvidrio,
            cantidadrecipientesvidrio, capacidadrecipientesvidrio, barricasmadera, cantidadbarricasmadera,
            capacidadbarricasmadera, controlhumedad, cantidadcontrolhumedad, caracteristicascontrolhumedad,
            controltemperatura, cantidadcontroltemperatura, caracteristicascontroltemperatu,
            otrocontrolvariables, opcioncontrolvariables, cantidadcontrolvariables,
            caracteristicascontrolvariables
        }))
        if (accion === 'fc_36UnidadProduccion') { props.history.push('/fc_36UnidadProduccion') }
        if (accion === 'fc_36UnidadEnvasado') { props.history.push('/fc_36UnidadEnvasado') }
        if (accion === 'fc_36') { props.history.push('/fc_36') }
    }*/
    const [openModalObservaciones, setOpenModalObservaciones] = React.useState(false);
    const handleOpenModalObservaciones = () => setOpenModalObservaciones(true);
    const handleCloseModalObservaciones = () => setOpenModalObservaciones(false);


    const handleCloseModalObservacionesX = () => {
        setOpenModalObservaciones(false);
        desactivarCheck(campoParaObservacion);
    }

    const desactivarCheck = (campoADesactivar) => {
        switch (campoADesactivar) {
            case 'nombrerazonsocial': setnombrerazonsocialcheck(false); break;
            case 'altainstalaciones': setaltainstalacionescheck(false); break;
            case 'bajainstalaciones': setbajainstalacionescheck(false); break;
            case 'fechasolicitud': setfechasolicitudcheck(false); break;
            case 'fechapropuesta': setfechapropuestacheck(false); break;
            case 'instalacionnumero': setinstalacionnumerocheck(false); break;
            case 'tipoinstalacionbodega': settipoinstalacionbodegacheck(false); break;
            case 'tipoinstalacionmaduracion': settipoinstalacionmaduracioncheck(false); break;
            case 'alias': setaliascheck(false); break;
            case 'calle': setcallecheck(false); break;
            case 'numeroexterior': setnumeroexteriorcheck(false); break;
            case 'numerointerior': setnumerointeriorcheck(false); break;
            case 'colonia': setcoloniacheck(false); break;
            case 'localidad': setlocalidadcheck(false); break;
            case 'municipio': setmunicipiocheck(false); break;
            case 'estado': setestadocheck(false); break;
            case 'codigopostal': setcodigopostalcheck(false); break;
            case 'referenciascercanas': setreferenciascercanascheck(false); break;
            case 'telefono': settelefonocheck(false); break;
            case 'correoelectronico': setcorreoelectronicocheck(false); break;
            case 'nombreresponsable': setnombreresponsablecheck(false); break;
            case 'tarimas': settarimascheck(false); break;
            case 'cantidadtarimas': setcantidadtarimascheck(false); break;
            case 'capacidadtarimas': setcapacidadtarimascheck(false); break;
            case 'patines': setpatinescheck(false); break;
            case 'cantidadpatines': setcantidadpatinescheck(false); break;
            case 'capacidadpatines': setcapacidadpatinescheck(false); break;
            case 'montacargas': setmontacargascheck(false); break;
            case 'cantidadmontacargas': setcantidadmontacargascheck(false); break;
            case 'capacidadmontacargas': setcapacidadmontacargascheck(false); break;
            case 'se_alamientos': setse_alamientoscheck(false); break;
            case 'cantidadse_alamientos': setcantidadse_alamientoscheck(false); break;
            case 'capacidadse_alamientos': setcapacidadse_alamientoscheck(false); break;
            case 'otroproductoterminado': setotroproductoterminadocheck(false); break;
            case 'opcionproductoterminado': setopcionproductoterminadocheck(false); break;
            case 'cantidadproductoterminado': setcantidadproductoterminadocheck(false); break;
            case 'capacidadproductoterminado': setcapacidadproductoterminadocheck(false); break;
            case 'recipientesvidrio': setrecipientesvidriocheck(false); break;
            case 'cantidadrecipientesvidrio': setcantidadrecipientesvidriocheck(false); break;
            case 'capacidadrecipientesvidrio': setcapacidadrecipientesvidriocheck(false); break;
            case 'barricasmadera': setbarricasmaderacheck(false); break;
            case 'cantidadbarricasmadera': setcantidadbarricasmaderacheck(false); break;
            case 'capacidadbarricasmadera': setcapacidadbarricasmaderacheck(false); break;
            case 'controlhumedad': setcontrolhumedadcheck(false); break;
            case 'cantidadcontrolhumedad': setcantidadcontrolhumedadcheck(false); break;
            case 'caracteristicascontrolhumedad': setcaracteristicascontrolhumedadcheck(false); break;
            case 'controltemperatura': setcontroltemperaturacheck(false); break;
            case 'cantidadcontroltemperatura': setcantidadcontroltemperaturacheck(false); break;
            case 'caracteristicascontroltemperatu': setcaracteristicascontroltemperatucheck(false); break;
            case 'otrocontrolvariables': setotrocontrolvariablescheck(false); break;
            case 'opcioncontrolvariables': setopcioncontrolvariablescheck(false); break;
            case 'cantidadcontrolvariables': setcantidadcontrolvariablescheck(false); break;
            case 'caracteristicascontrolvariables': setcaracteristicascontrolvariablescheck(false); break;



        }
        setObservacionArea('')
        setCampoParaObservacion('')
    }

    const [observacionArea, setObservacionArea] = useStateIfMounted('')
    let [campoParaObservacion, setCampoParaObservacion] = useStateIfMounted('')
    const mostrarModal = (campo) => {
        setCampoParaObservacion(campo)
    }
    const modalComponentObservaciones = (campo) => {
        return (
            <Fragment>
                <Modal
                    open={openModalObservaciones}
                    onClose={handleCloseModalObservacionesX}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    disableEnforceFocus
                >
                    <Box sx={style}>

                        <div >

                        </div>
                        <div align="center">
                            <div className={`${estilos.textRight}`}>
                                <button className='btn' onClick={handleCloseModalObservacionesX}>
                                    <FontAwesomeIcon icon={faXmark} />
                                </button>
                            </div>
                            <label align="center"> <b>OBSERVACIONES</b></label>
                        </div>
                        <textarea type="textarea" rows="3" className="form-control" id=""
                            placeholder='Detalle de la observacion.'
                            value={observacionArea} onChange={e => setObservacionArea(e.target.value)} />

                        <br />
                        <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                            <button className='btn btn-dark' onClick={e => botonGuardarObservaciones(observacionArea)}>Aceptar</button>
                        </div>

                    </Box>
                </Modal>
            </Fragment>

        )
    }
    const botonGuardarObservaciones = async (observacion) => {
        observaciones[campoParaObservacion] = observacion
        handleCloseModalObservaciones()
        setObservacionArea('')
        setCampoParaObservacion('')
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);

    const botonAceptar = async () => {
        handleOpenModalAceptar()
    }
    const modalComponentAceptar = () => {
        return (
            <Fragment>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="red" align='center'>
                            Advertencia!
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Está a punto de aceptar el anexo unidad de almacen, ya no podrá seguir revisando esta solicitud
                            y los datos se guardarán tal cual fue establecido.<br /> <strong>¿Desea continuar?</strong>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={botonAceptarSolicitud}>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </Fragment>

        )
    }
    const modoRevision = useSelector(store => store.FC_36SolicitudAtencionACliente.modoRevision)
    
    const botonAceptarSolicitud = async () => {
        if (modoRevision) {
            if (!(JSON.stringify([]) === JSON.stringify(anexoUnidadAlmacenMapRevision)) && anexoUnidadAlmacenMapRevision !== undefined) {
                for (const anexo of anexoUnidadAlmacenMapRevision) {
                    const id = anexo.data.idfc36_anexounidaddealmacen
                    if (id === anexoUnidadAlmacenMap.idfc36_anexounidaddealmacen) {
                        await dispatch(eliminarFC_36AnexoAlmacenMapRevision(id))
                    } else {
                        // console.log("no entro")
                    }
                }
            }
            const res = await dispatch(agregarFC_36AnexoUnidadAlmacenMapRevision({
                idfc36_anexounidaddealmacen: anexoUnidadAlmacenMap.idfc36_anexounidaddealmacen,
                idfc36_anexounidaddealmacenmap: anexoUnidadAlmacenMap.idfc36_anexounidaddealmacenmap,
                nombrerazonsocialcheck, altainstalacionescheck, bajainstalacionescheck, fechasolicitudcheck, fechapropuestacheck,
                instalacionnumerocheck, tipoinstalacionbodegacheck, tipoinstalacionmaduracioncheck, aliascheck, callecheck,
                numeroexteriorcheck, numerointeriorcheck, coloniacheck, localidadcheck, municipiocheck, estadocheck,
                codigopostalcheck, referenciascercanascheck, telefonocheck, correoelectronicocheck, nombreresponsablecheck,
                tarimascheck, cantidadtarimascheck, capacidadtarimascheck, patinescheck, cantidadpatinescheck,
                capacidadpatinescheck, montacargascheck, cantidadmontacargascheck, capacidadmontacargascheck,
                se_alamientoscheck, cantidadse_alamientoscheck, capacidadse_alamientoscheck, otroproductoterminadocheck,
                opcionproductoterminadocheck, cantidadproductoterminadocheck, capacidadproductoterminadocheck,
                recipientesvidriocheck, cantidadrecipientesvidriocheck, capacidadrecipientesvidriocheck, barricasmaderacheck,
                cantidadbarricasmaderacheck, capacidadbarricasmaderacheck, controlhumedadcheck, cantidadcontrolhumedadcheck,
                caracteristicascontrolhumedadcheck, controltemperaturacheck, cantidadcontroltemperaturacheck,
                caracteristicascontroltemperatucheck, otrocontrolvariablescheck, opcioncontrolvariablescheck,
                cantidadcontrolvariablescheck, caracteristicascontrolvariablescheck,
                nombrerazonsocial: observaciones.nombrerazonsocial, altainstalaciones: observaciones.altainstalaciones,
                bajainstalaciones: observaciones.bajainstalaciones, fechasolicitud: observaciones.fechasolicitud,
                fechapropuesta: observaciones.fechapropuesta, instalacionnumero: observaciones.instalacionnumero,
                tipoinstalacionbodega: observaciones.tipoinstalacionbodega, tipoinstalacionmaduracion: observaciones.tipoinstalacionmaduracion,
                alias: observaciones.alias, calle: observaciones.calle, numeroexterior: observaciones.numeroexterior,
                numerointerior: observaciones.numerointerior, colonia: observaciones.colonia, localidad: observaciones.localidad,
                municipio: observaciones.municipio, estado: observaciones.estado, codigopostal: observaciones.codigopostal,
                referenciascercanas: observaciones.referenciascercanas, telefono: observaciones.telefono,
                correoelectronico: observaciones.correoelectronico, nombreresponsable: observaciones.nombreresponsable,
                tarimas: observaciones.tarimas, cantidadtarimas: observaciones.cantidadtarimas,
                capacidadtarimas: observaciones.capacidadtarimas, patines: observaciones.patines,
                cantidadpatines: observaciones.cantidadpatines, capacidadpatines: observaciones.capacidadpatines,
                montacargas: observaciones.montacargas, cantidadmontacargas: observaciones.cantidadmontacargas,
                capacidadmontacargas: observaciones.capacidadmontacargas, se_alamientos: observaciones.se_alamientos,
                cantidadse_alamientos: observaciones.cantidadse_alamientos, capacidadse_alamientos: observaciones.capacidadse_alamientos,
                otroproductoterminado: observaciones.otroproductoterminado, opcionproductoterminado: observaciones.opcionproductoterminado,
                cantidadproductoterminado: observaciones.cantidadproductoterminado,
                capacidadproductoterminado: observaciones.capacidadproductoterminado,
                recipientesvidrio: observaciones.recipientesvidrio, cantidadrecipientesvidrio: observaciones.cantidadrecipientesvidrio,
                capacidadrecipientesvidrio: observaciones.capacidadrecipientesvidrio, barricasmadera: observaciones.barricasmadera,
                cantidadbarricasmadera: observaciones.cantidadbarricasmadera, capacidadbarricasmadera: observaciones.capacidadbarricasmadera,
                controlhumedad: observaciones.controlhumedad, cantidadcontrolhumedad: observaciones.cantidadcontrolhumedad,
                caracteristicascontrolhumedad: observaciones.caracteristicascontrolhumedad, controltemperatura: observaciones.controltemperatura,
                cantidadcontroltemperatura: observaciones.cantidadcontroltemperatura,
                caracteristicascontroltemperatu: observaciones.caracteristicascontroltemperatu,
                otrocontrolvariables: observaciones.otrocontrolvariables, opcioncontrolvariables: observaciones.opcioncontrolvariables,
                cantidadcontrolvariables: observaciones.cantidadcontrolvariables,
                caracteristicascontrolvariables: observaciones.caracteristicascontrolvariables

            }))
            if (res) {
                props.history.push('/fc_36')
            }
        } else {
            const id = anexoAlmacenFormato[0].idfc36_anexounidaddealmacen

            if (anexoUnidadAlmacenMap.length > 0) {
                for (const anexo of anexoUnidadAlmacenMap) {
                    if (id == anexo.data.id) {
                        await dispatch(eliminarFC_36AnexoAlmacenMap(id))
                    } else {
                        // console.log("no entro")
                    }
                }
            }
            const res = await dispatch(agregarFC_36AnexoUnidadAlmacenMap({
                id: anexoAlmacenFormato[0].idfc36_anexounidaddealmacen,
                nombrerazonsocialcheck, altainstalacionescheck, bajainstalacionescheck, fechasolicitudcheck, fechapropuestacheck,
                instalacionnumerocheck, tipoinstalacionbodegacheck, tipoinstalacionmaduracioncheck, aliascheck, callecheck,
                numeroexteriorcheck, numerointeriorcheck, coloniacheck, localidadcheck, municipiocheck, estadocheck,
                codigopostalcheck, referenciascercanascheck, telefonocheck, correoelectronicocheck, nombreresponsablecheck,
                tarimascheck, cantidadtarimascheck, capacidadtarimascheck, patinescheck, cantidadpatinescheck,
                capacidadpatinescheck, montacargascheck, cantidadmontacargascheck, capacidadmontacargascheck,
                se_alamientoscheck, cantidadse_alamientoscheck, capacidadse_alamientoscheck, otroproductoterminadocheck,
                opcionproductoterminadocheck, cantidadproductoterminadocheck, capacidadproductoterminadocheck,
                recipientesvidriocheck, cantidadrecipientesvidriocheck, capacidadrecipientesvidriocheck, barricasmaderacheck,
                cantidadbarricasmaderacheck, capacidadbarricasmaderacheck, controlhumedadcheck, cantidadcontrolhumedadcheck,
                caracteristicascontrolhumedadcheck, controltemperaturacheck, cantidadcontroltemperaturacheck,
                caracteristicascontroltemperatucheck, otrocontrolvariablescheck, opcioncontrolvariablescheck,
                cantidadcontrolvariablescheck, caracteristicascontrolvariablescheck,
                nombrerazonsocial: observaciones.nombrerazonsocial, altainstalaciones: observaciones.altainstalaciones,
                bajainstalaciones: observaciones.bajainstalaciones, fechasolicitud: observaciones.fechasolicitud,
                fechapropuesta: observaciones.fechapropuesta, instalacionnumero: observaciones.instalacionnumero,
                tipoinstalacionbodega: observaciones.tipoinstalacionbodega, tipoinstalacionmaduracion: observaciones.tipoinstalacionmaduracion,
                alias: observaciones.alias, calle: observaciones.calle, numeroexterior: observaciones.numeroexterior,
                numerointerior: observaciones.numerointerior, colonia: observaciones.colonia, localidad: observaciones.localidad,
                municipio: observaciones.municipio, estado: observaciones.estado, codigopostal: observaciones.codigopostal,
                referenciascercanas: observaciones.referenciascercanas, telefono: observaciones.telefono,
                correoelectronico: observaciones.correoelectronico, nombreresponsable: observaciones.nombreresponsable,
                tarimas: observaciones.tarimas, cantidadtarimas: observaciones.cantidadtarimas,
                capacidadtarimas: observaciones.capacidadtarimas, patines: observaciones.patines,
                cantidadpatines: observaciones.cantidadpatines, capacidadpatines: observaciones.capacidadpatines,
                montacargas: observaciones.montacargas, cantidadmontacargas: observaciones.cantidadmontacargas,
                capacidadmontacargas: observaciones.capacidadmontacargas, se_alamientos: observaciones.se_alamientos,
                cantidadse_alamientos: observaciones.cantidadse_alamientos, capacidadse_alamientos: observaciones.capacidadse_alamientos,
                otroproductoterminado: observaciones.otroproductoterminado, opcionproductoterminado: observaciones.opcionproductoterminado,
                cantidadproductoterminado: observaciones.cantidadproductoterminado,
                capacidadproductoterminado: observaciones.capacidadproductoterminado,
                recipientesvidrio: observaciones.recipientesvidrio, cantidadrecipientesvidrio: observaciones.cantidadrecipientesvidrio,
                capacidadrecipientesvidrio: observaciones.capacidadrecipientesvidrio, barricasmadera: observaciones.barricasmadera,
                cantidadbarricasmadera: observaciones.cantidadbarricasmadera, capacidadbarricasmadera: observaciones.capacidadbarricasmadera,
                controlhumedad: observaciones.controlhumedad, cantidadcontrolhumedad: observaciones.cantidadcontrolhumedad,
                caracteristicascontrolhumedad: observaciones.caracteristicascontrolhumedad, controltemperatura: observaciones.controltemperatura,
                cantidadcontroltemperatura: observaciones.cantidadcontroltemperatura,
                caracteristicascontroltemperatu: observaciones.caracteristicascontroltemperatu,
                otrocontrolvariables: observaciones.otrocontrolvariables, opcioncontrolvariables: observaciones.opcioncontrolvariables,
                cantidadcontrolvariables: observaciones.cantidadcontrolvariables,
                caracteristicascontrolvariables: observaciones.caracteristicascontrolvariables

            }))
            if (res) {
                props.history.push('/fc_36')
            }
        }
    }

    return (
        <Fragment>
            <div className='row mt-2'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mt-3 text-center'>
                    {
                        anexoAlmacenEditable.length === 0 ?
                            (
                                <h2 className='text-center'>ANEXO Unidad de Almacén</h2>) :
                            (

                                <div className='text-center'>
                                    <h4 className='text-center' ><strong>Editando</strong> anexo Unidad de Almacén</h4>
                                </div>
                            )
                    }
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 text-center' >
                    <button onClick={botonRegresarFC_36} className='btn btnNaranja zoom-in-zoom-out'>Regresar a solicitud principal
                    </button>
                </div>
            </div>



            <div className='container2'>
                {
                    paginaActiva === 1 ?
                        (
                            <Fragment>
                                <div className='row align-items-center'>
                                    <h4 className='textoNormal'><i>De clic en el recuadro del <FontAwesomeIcon icon={faEye} /> para hacer observaciones.</i></h4>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.divBorderNaranja}`}>
                                        <h6 className='text-center'>INFORMACIÓN DEL SOLICITANTE</h6>
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" min='1' className={`form-control ${anexoUnidadAlmacenMap.nombrerazonsocialcheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.nombrerazonsocialcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Nombre o razon social' value={nombrerazonsocial} onChange={e => setnombrerazonsocialalmacen(e.target.value)} />
                                            <label className="floatingInput">Nombre o razón social:</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.nombrerazonsocial}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={nombrerazonsocialcheck} onChange={e => checknombrerazonsocialcheck()} checked={nombrerazonsocialcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                </div>
                                <div className='row justify-content-start'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.divBorderNaranja}`}>
                                        <h6 className='text-center'><b>SERVICIO SOLICITADO:</b></h6>
                                    </div>
                                    <div className='col-md-6 text-center'>
                                        <br />
                                        <input className={`form-check-input me-1 ${anexoUnidadAlmacenMap.altainstalacionescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.altainstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" value="" id="alta" checked={altainstalaciones} onChange={e => setAccionInstalacion(e.target)} />
                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                            Alta de instalaciones:
                                        </label>
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.altainstalaciones}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={altainstalacionescheck} onChange={e => checkaltainstalacionescheck()} checked={altainstalacionescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        <br />
                                    </div>
                                    <div className='col-md-6 text-center'>
                                        <br />
                                        <input className={`form-check-input me-1 ${anexoUnidadAlmacenMap.bajainstalacionescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.bajainstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" value="" id="baja" checked={bajainstalaciones} onChange={e => setAccionInstalacion(e.target)} />
                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                            Baja de instalaciones:
                                        </label>
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.bajainstalaciones}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={bajainstalacionescheck} onChange={e => checkbajainstalacionescheck()} checked={bajainstalacionescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        <br />
                                    </div>
                                    <div className='col-md-6 text-center'>
                                        <br />

                                        <div className="form-floating mb-3">
                                            <input type="date" className={`form-control ${anexoUnidadAlmacenMap.fechasolicitudcheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.fechasolicitudcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Fecha de solicitud' value={fechasolicitud} onChange={e => setfechasolicitudalmacen(e.target.value)} />
                                            <label className="floatingInput">Fecha de solicitud:</label></div>
                                        <br></br> <span className='text-danger'>{anexoUnidadAlmacenMap?.fechasolicitud}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={fechasolicitudcheck} onChange={e => checkfechasolicitudcheck()} checked={fechasolicitudcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6 text-center'>
                                        <br />
                                        <div className="form-floating mb-3">
                                            <input type="date" className={`form-control ${anexoUnidadAlmacenMap.fechapropuestacheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.fechapropuestacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Fecha propuesta' value={fechapropuesta} onChange={e => setfechapropuestaalmacen(e.target.value)} />
                                            <label className="floatingInput">Fecha de visita propuesta</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.fechapropuesta}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={fechapropuestacheck} onChange={e => checkfechapropuestacheck()} checked={fechapropuestacheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                        </div>
                                    </div>
                                </div>
                                <div className='row align-items-center'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.divBorderNaranja}`}>
                                        <h6 className='text-center'>INFORMACIÓN DE LAS INSTALACIONES</h6>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                        <br />
                                        <div className="form-floating mb-3">

                                            <input type="number" className={`form-control ${anexoUnidadAlmacenMap.instalacionnumerocheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.instalacionnumerocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='no. de instalcion' value={instalacionnumero} onChange={e => setinstalacionnumeroalmacen(e.target.valueAsNumber)} />
                                            <label className="floatingInput">Instalación número</label><input className="form-check-input" type="checkbox"
                                                value={instalacionnumerocheck} onChange={e => checkinstalacionnumerocheck()} checked={instalacionnumerocheck} />
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.instalacionnumero}</span><br></br>
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación</div>
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8'>

                                        <label className="floatingInput">Tipo de instalación: </label>
                                        <div className='row'>
                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                                <div className="form-floating">
                                                    <h5 className="">
                                                        <input className={`form-check-input me-1 ${anexoUnidadAlmacenMap.tipoinstalacionbodegacheck !== undefined ? (
                                                            anexoUnidadAlmacenMap?.tipoinstalacionbodegacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="radio" name="tipo" checked={tipoinstalacionbodega} onChange={e => settipoinstalacionbodega(e.target.checked)} />
                                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.tipoinstalacionbodega}</span><br></br>Bodega</h5>

                                                </div>
                                                <input className="form-check-input" type="checkbox"
                                                    value={tipoinstalacionbodegacheck} onChange={e => checktipoinstalacionbodegacheck()} checked={tipoinstalacionbodegacheck} />
                                                <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                            </div>

                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                                <div className="form-floating">
                                                    <h5 className=""><input className={`form-check-input me-1 ${anexoUnidadAlmacenMap.tipoinstalacionmaduracioncheck !== undefined ? (
                                                        anexoUnidadAlmacenMap?.tipoinstalacionmaduracioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="radio" name="tipo" checked={tipoinstalacionmaduracion} onChange={e => settipoinstalacionmaduracion(e.target.checked)} />
                                                        Maduración</h5>
                                                </div>
                                                <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.tipoinstalacionmaduracion}</span><br></br>
                                                <input className="form-check-input" type="checkbox"
                                                    value={tipoinstalacionmaduracioncheck} onChange={e => checktipoinstalacionmaduracioncheck()} checked={tipoinstalacionmaduracioncheck} />
                                                <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12'>
                                        <div className="form-floating">
                                            <label className="floatingInput"></label>
                                            <input type="text" className={`form-control ${anexoUnidadAlmacenMap.aliascheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.aliascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Nombre de la instalacion' value={alias} onChange={e => setaliasalmacen(e.target.value)} />
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.alias}</span><br></br>
                                            <input className="form-check-input" type="checkbox"
                                                value={aliascheck} onChange={e => checkaliascheck()} checked={aliascheck} />
                                            <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                            <label className="aling-center"><small>Asignar un "Alias" para identificar cada instalación, esto permitirá diferenciarlas.</small></label>
                                        </div>
                                    </div>
                                </div>
                                <div className='row justify-content-start'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.divBorderNaranja}`}>
                                        <h6 className='text-center'><b>DOMICILIO DE LA INSTALACIÓN:</b></h6>
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadAlmacenMap.callecheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.callecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Calle' value={calle} onChange={e => setcallealmacen(e.target.value)} />
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.calle}</span><br></br>
                                            <label className="floatingInput">Calle</label>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={callecheck} onChange={e => checkcallecheck()} checked={callecheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>

                                        <div className="form-floating mb-3">
                                            <input type="number" min='0' className={`form-control ${anexoUnidadAlmacenMap.numeroexteriorcheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.numeroexteriorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='N° exterior' value={numeroexterior} onChange={e => setnumeroexterioralmacen(e.target.valueAsNumber)} />
                                            <label className="floatingInput">Número exterior</label>
                                            <br></br> <span className='text-danger'>{anexoUnidadAlmacenMap?.numeroexterior}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={numeroexteriorcheck} onChange={e => checknumeroexteriorcheck()} checked={numeroexteriorcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>

                                        <div className="form-floating mb-3">
                                            <input type="number" min='0' className={`form-control ${anexoUnidadAlmacenMap.numerointeriorcheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.numerointeriorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='N° interior' value={numerointerior} onChange={e => setnumerointerioralmacen(e.target.valueAsNumber)} />
                                            <label className="floatingInput">Número interior</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.numerointerior}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={numerointeriorcheck} onChange={e => checknumerointeriorcheck()} checked={numerointeriorcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadAlmacenMap.coloniacheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.coloniacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Colonia' value={colonia} onChange={e => setcoloniaalmacen(e.target.value)} />
                                            <label className="floatingInput">Colonia</label>
                                            <br></br> <span className='text-danger'>{anexoUnidadAlmacenMap?.colonia}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={coloniacheck} onChange={e => checkcoloniacheck()} checked={coloniacheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadAlmacenMap.localidadcheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.localidadcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Localidad' value={localidad} onChange={e => setlocalidadalmacen(e.target.value)} />
                                            <label className="floatingInput">Localidad</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.localidad}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={localidadcheck} onChange={e => checklocalidadcheck()} checked={localidadcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadAlmacenMap.municipiocheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.municipiocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Delegacion/Municipio' value={municipio} onChange={e => setmunicipioalmacen(e.target.value)} />
                                            <label className="floatingInput">Delegación/Municipio</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.municipio}</span><br></br>

                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={municipiocheck} onChange={e => checkmunicipiocheck()} checked={municipiocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadAlmacenMap.estadocheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.estadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Estado' value={estado} onChange={e => setestadoalmacen(e.target.value)} />
                                            <label className="floatingInput">Estado</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.estado}</span><br></br></div>
                                        <input className="form-check-input" type="checkbox"
                                            value={estadocheck} onChange={e => checkestadocheck()} checked={estadocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="number" min='0' className={`form-control ${anexoUnidadAlmacenMap.codigopostalcheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.codigopostalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Codigo postal' value={codigopostal} onChange={e => setcodigopostalalmacen(e.target.value)} />
                                            <label className="floatingInput">Código postal</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.codigopostal}</span><br></br></div>
                                        <input className="form-check-input" type="checkbox"
                                            value={codigopostalcheck} onChange={e => checkcodigopostalcheck()} checked={codigopostalcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" min='0' className={`form-control ${anexoUnidadAlmacenMap.referenciascercanascheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.referenciascercanascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Indique los lugares cercanos que permitan localizar con facilidad sus instalaciones, o las calles entre las que se encuentra.' value={referenciascercanas} onChange={e => setreferenciascercanasalmacen(e.target.value)} />
                                            <label className="floatingInput">Referencias cercanas:</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.referenciascercanas}</span><br></br></div>
                                        <input className="form-check-input" type="checkbox"
                                            value={referenciascercanascheck} onChange={e => checkreferenciascercanascheck()} checked={referenciascercanascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="number" className={`form-control ${anexoUnidadAlmacenMap.telefonocheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Telefono' value={telefono} onChange={e => settelefonoalmacen(e.target.value)} />
                                            <label className="floatingInput">Teléfono</label>
                                            <br></br> <span className='text-danger'>{anexoUnidadAlmacenMap?.telefono}</span><br></br></div>
                                        <input className="form-check-input" type="checkbox"
                                            value={telefonocheck} onChange={e => checktelefonocheck()} checked={telefonocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>

                                        <div className="form-floating mb-3">
                                            <input type="email" className={`form-control ${anexoUnidadAlmacenMap.correoelectronicocheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='ejemplo@gmail.com' value={correoelectronico} onChange={e => setcorreoelectronicoalmacen(e.target.value)} />
                                            <label className="floatingInput">Correo electrónico</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.correoelectronico}</span><br></br></div>
                                        <input className="form-check-input" type="checkbox"
                                            value={correoelectronicocheck} onChange={e => checkcorreoelectronicocheck()} checked={correoelectronicocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-12'>

                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control ${anexoUnidadAlmacenMap.nombreresponsablecheck !== undefined ? (
                                                anexoUnidadAlmacenMap?.nombreresponsablecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Nombre del responsable' value={nombreresponsable} onChange={e => setnombreresponsablealmacen(e.target.value)} />
                                            <label className="floatingInput">Nombre del responsable</label>
                                            <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.nombreresponsable}</span><br></br>
                                        </div>
                                        <input className="form-check-input" type="checkbox"
                                            value={nombreresponsablecheck} onChange={e => checknombreresponsablecheck()} checked={nombreresponsablecheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                </div>
                            </Fragment>
                        )
                        :
                        (
                            <Fragment>
                                <div className='row align-items-center'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.divBorderNaranja}`}>
                                        <h6 className='text-center'>DESCRIPCIÓN DE LAS INSTALACIONES</h6>
                                        <b>Unidad de almacén de producto terminado</b>
                                    </div>


                                </div>
                                <div className='row align-items-center'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.labelNaranja}`}>

                                        <h6 className='text-center'><b>Equipo</b></h6>
                                    </div>
                                    <div className='row align-items-center'>
                                        <div className='col-md-6'>
                                            <label className="ms-3">Equipo</label>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className="ms-3">Cantidad</label>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className="ms-3">Capacidad</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='row align-items-center'>
                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.tarimascheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.tarimascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' id="" checked={tarimas} value={tarimas} onChange={e => settarimas(e.target.checked)} />
                                        <label className="ms-3">Tarimas</label>
                                        <br /> <span className='text-danger'>{anexoUnidadAlmacenMap?.tarimas}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={tarimascheck} onChange={e => checktarimascheck()} checked={tarimascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadtarimascheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadtarimascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadtarimas} onChange={e => setcantidadtarimas(e.target.valueAsNumber)} disabled={!tarimas} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadtarimas}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadtarimascheck} onChange={e => checkcantidadtarimascheck()} checked={cantidadtarimascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.capacidadtarimascheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.capacidadtarimascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Capacidad' value={capacidadtarimas} onChange={e => setcapacidadtarimas(e.target.valueAsNumber)} disabled={!tarimas} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.capacidadtarimas}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={capacidadtarimascheck} onChange={e => checkcapacidadtarimascheck()} checked={capacidadtarimascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.patinescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.patinescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' id="" checked={patines} value={patines} onChange={e => setpatines(e.target.checked)} />
                                        <label className="ms-3">Patines</label>
                                        <br /><span className='text-danger'>{anexoUnidadAlmacenMap?.patines}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={patinescheck} onChange={e => checkpatinescheck()} checked={patinescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadpatinescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadpatinescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadpatines} onChange={e => setcantidadpatines(e.target.valueAsNumber)} disabled={!patines} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadpatines}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadpatinescheck} onChange={e => checkcantidadpatinescheck()} checked={cantidadpatinescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.capacidadpatinescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.capacidadpatinescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Capacidad' value={capacidadpatines} onChange={e => setcapacidadpatines(e.target.valueAsNumber)} disabled={!patines} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.capacidadpatines}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={capacidadpatinescheck} onChange={e => checkcapacidadpatinescheck()} checked={capacidadpatinescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.montacargascheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.montacargascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' id="" checked={montacargas} value={montacargas} onChange={e => setmontacargas(e.target.checked)} />
                                        <label className="ms-3">Montacargas</label>
                                        <br /><span className='text-danger'>{anexoUnidadAlmacenMap?.montacargas}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={montacargascheck} onChange={e => checkmontacargascheck()} checked={montacargascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadmontacargascheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadmontacargascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadmontacargas} onChange={e => setcantidadmontacargas(e.target.valueAsNumber)} disabled={!montacargas} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadmontacargas}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadmontacargascheck} onChange={e => checkcantidadmontacargascheck()} checked={cantidadmontacargascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.capacidadmontacargascheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.capacidadmontacargascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Capacidad' value={capacidadmontacargas} onChange={e => setcapacidadmontacargas(e.target.valueAsNumber)} disabled={!montacargas} />
                                        <br></br> <span className='text-danger'>{anexoUnidadAlmacenMap?.capacidadmontacargas}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={capacidadmontacargascheck} onChange={e => checkcapacidadmontacargascheck()} checked={capacidadmontacargascheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.se_alamientoscheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.se_alamientoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' id="" checked={se_alamientos} value={se_alamientos} onChange={e => setse_alamientos(e.target.checked)} />
                                        <label className="ms-3">Señalamientos</label>
                                        <br /><span className='text-danger'>{anexoUnidadAlmacenMap?.se_alamientos}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={se_alamientoscheck} onChange={e => checkse_alamientoscheck()} checked={se_alamientoscheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadse_alamientoscheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadse_alamientoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadse_alamientos} onChange={e => setcantidadse_alamientos(e.target.valueAsNumber)} disabled={!se_alamientos} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadse_alamientos}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadse_alamientoscheck} onChange={e => checkcantidadse_alamientoscheck()} checked={cantidadse_alamientoscheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.capacidadse_alamientoscheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.capacidadse_alamientoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Capacidad' value={capacidadse_alamientos} onChange={e => setcapacidadse_alamientos(e.target.valueAsNumber)} disabled={!se_alamientos} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.capacidadse_alamientos}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={capacidadse_alamientoscheck} onChange={e => checkcapacidadse_alamientoscheck()} checked={capacidadse_alamientoscheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-3'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.otroproductoterminadocheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.otroproductoterminadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' id="" checked={otroproductoterminado} value={otroproductoterminado} onChange={e => setotroproductoterminado(e.target.checked)} />
                                        <label className="ms-3">Otro</label>
                                        <br /><span className='text-danger'>{anexoUnidadAlmacenMap?.otroproductoterminado}</span><br></br>

                                        <input className="form-check-input" type="checkbox"
                                            value={otroproductoterminadocheck} onChange={e => checkotroproductoterminadocheck()} checked={otroproductoterminadocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="text" className={`form-control ${anexoUnidadAlmacenMap.opcionproductoterminadocheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.opcionproductoterminadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Otro' value={opcionproductoterminado} onChange={e => setopcionproductoterminado(e.target.value)} disabled={!otroproductoterminado} />
                                        <br /><span className='text-danger'>{anexoUnidadAlmacenMap?.opcionproductoterminado}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={opcionproductoterminadocheck} onChange={e => checkopcionproductoterminadocheck()} checked={opcionproductoterminadocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadproductoterminadocheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadproductoterminadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadproductoterminado} onChange={e => setcantidadproductoterminado(e.target.valueAsNumber)} disabled={!otroproductoterminado} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadproductoterminado}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadproductoterminadocheck} onChange={e => checkcantidadproductoterminadocheck()} checked={cantidadproductoterminadocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.capacidadproductoterminadocheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.capacidadproductoterminadocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Capacidad' value={capacidadproductoterminado} onChange={e => setcapacidadproductoterminado(e.target.valueAsNumber)} disabled={!otroproductoterminado} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.capacidadproductoterminado}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={capacidadproductoterminadocheck} onChange={e => checkcapacidadproductoterminadocheck()} checked={capacidadproductoterminadocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                </div>
                                <br />
                                <div className='row align-items-center'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.labelNaranja}`}>

                                        <h6 className='text-center'><b>Maduracion-Añejamiento de producto</b></h6>
                                    </div>
                                    <div className='row align-items-center'>
                                        <div className='col-md-6'>
                                            <label className="ms-3">Recipientes </label>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className="ms-3">Cantidad</label>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className="ms-3">Capacidad</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.recipientesvidriocheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.recipientesvidriocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='tarimas' id="" checked={recipientesvidrio} value={recipientesvidrio} onChange={e => setrecipientesvidrio(e.target.checked)} />
                                        <label className="ms-3">Recipientes de vidrio</label>
                                        <br /><span className='text-danger'>{anexoUnidadAlmacenMap?.recipientesvidrio}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={recipientesvidriocheck} onChange={e => checkrecipientesvidriocheck()} checked={recipientesvidriocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadrecipientesvidriocheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadrecipientesvidriocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadrecipientesvidrio} onChange={e => setcantidadrecipientesvidrio(e.target.valueAsNumber)} disabled={!recipientesvidrio} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadrecipientesvidrio}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadrecipientesvidriocheck} onChange={e => checkcantidadrecipientesvidriocheck()} checked={cantidadrecipientesvidriocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.capacidadrecipientesvidriocheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.capacidadrecipientesvidriocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Capacidad' value={capacidadrecipientesvidrio} onChange={e => setcapacidadrecipientesvidrio(e.target.valueAsNumber)} disabled={!recipientesvidrio} />
                                        <br></br> <span className='text-danger'>{anexoUnidadAlmacenMap?.capacidadrecipientesvidrio}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={capacidadrecipientesvidriocheck} onChange={e => checkcapacidadrecipientesvidriocheck()} checked={capacidadrecipientesvidriocheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.barricasmaderacheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.barricasmaderacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' id="" checked={barricasmadera} value={barricasmadera} onChange={e => setbarricasmadera(e.target.checked)} />
                                        <label className="ms-3">Barricas de madera</label>
                                        <br /> <span className='text-danger'>{anexoUnidadAlmacenMap?.barricasmadera}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={barricasmaderacheck} onChange={e => checkbarricasmaderacheck()} checked={barricasmaderacheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>

                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadbarricasmaderacheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadbarricasmaderacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadbarricasmadera} onChange={e => setcantidadbarricasmadera(e.target.valueAsNumber)} disabled={!barricasmadera} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadbarricasmadera}</span><br></br>
                                        <input className={`form-control ${anexoUnidadAlmacenMap.cantidadbarricasmaderacheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadbarricasmaderacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                            value={cantidadbarricasmaderacheck} onChange={e => checkcantidadbarricasmaderacheck()} checked={cantidadbarricasmaderacheck} />

                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.capacidadbarricasmaderacheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.capacidadbarricasmaderacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Capacidad' value={capacidadbarricasmadera} onChange={e => setcapacidadbarricasmadera(e.target.valueAsNumber)} disabled={!barricasmadera} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.capacidadbarricasmadera}</span><br></br>

                                        <input className="form-check-input" type="checkbox"
                                            value={capacidadbarricasmaderacheck} onChange={e => checkcapacidadbarricasmaderacheck()} checked={capacidadbarricasmaderacheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                </div>
                                <br />
                                <div className='row align-items-center'>
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.labelNaranja}`}>
                                        <h6 className='text-center'><b>Control de variables</b></h6>
                                    </div>
                                    <div className='row align-items-center'>
                                        <div className='col-md-6'>
                                            <label className="ms-3">Equipo</label>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className="ms-3">Cantidad</label>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className="ms-3">Caracteristicas</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.controlhumedadcheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.controlhumedadcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='certificado' id="" checked={controlhumedad} value={controlhumedad} onChange={e => setcontrolhumedad(e.target.checked)} />
                                        <label className="ms-3">Control de humedad</label>
                                        <br /> <span className='text-danger'>{anexoUnidadAlmacenMap?.controlhumedad}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={controlhumedadcheck} onChange={e => checkcontrolhumedadcheck()} checked={controlhumedadcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadcontrolhumedadcheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadcontrolhumedadcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadcontrolhumedad} onChange={e => setcantidadcontrolhumedad(e.target.valueAsNumber)} disabled={!controlhumedad} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadcontrolhumedad}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadcontrolhumedadcheck} onChange={e => checkcantidadcontrolhumedadcheck()} checked={cantidadcontrolhumedadcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="text" className={`form-control ${anexoUnidadAlmacenMap.caracteristicascontrolhumedadcheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.caracteristicascontrolhumedadcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Características' value={caracteristicascontrolhumedad} onChange={e => setcaracteristicascontrolhumedad(e.target.value)} disabled={!controlhumedad} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.caracteristicascontrolhumedad}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={caracteristicascontrolhumedadcheck} onChange={e => checkcaracteristicascontrolhumedadcheck()} checked={caracteristicascontrolhumedadcheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-6'>
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.controltemperaturacheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.controltemperaturacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='filtroPrensa' id="" checked={controltemperatura} value={controltemperatura} onChange={e => setcontroltemperatura(e.target.checked)} />
                                        <label className="ms-3">Control de temperatura</label>
                                        <br /><span className='text-danger'>{anexoUnidadAlmacenMap?.controltemperatura}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={controltemperaturacheck} onChange={e => checkcontroltemperaturacheck()} checked={controltemperaturacheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadcontroltemperaturacheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadcontroltemperaturacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadcontroltemperatura} onChange={e => setcantidadcontroltemperatura(e.target.valueAsNumber)} disabled={!controltemperatura} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadcontroltemperatura}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadcontroltemperaturacheck} onChange={e => checkcantidadcontroltemperaturacheck()} checked={cantidadcontroltemperaturacheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="text" className={`form-control ${anexoUnidadAlmacenMap.caracteristicascontroltemperatucheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.caracteristicascontroltemperatucheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Caracterisiticas' value={caracteristicascontroltemperatu} onChange={e => setcaracteristicascontroltemperatu(e.target.value)} disabled={!controltemperatura} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.caracteristicascontroltemperatu}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={caracteristicascontroltemperatucheck} onChange={e => checkcaracteristicascontroltemperatucheck()} checked={caracteristicascontroltemperatucheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3' >
                                        <input className={`ms-2 form-check-input me-1 ${anexoUnidadAlmacenMap.otrocontrolvariablescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.otrocontrolvariablescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox" name='Otro' id="" checked={otrocontrolvariables} value={otrocontrolvariables} onChange={e => setotrocontrolvariables(e.target.checked)} />
                                        <label className="ms-3">Otro</label>
                                        <br />   <span className='text-danger'>{anexoUnidadAlmacenMap?.otrocontrolvariables}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={otrocontrolvariablescheck} onChange={e => checkotrocontrolvariablescheck()} checked={otrocontrolvariablescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="text" className={`form-control ${anexoUnidadAlmacenMap.opcioncontrolvariablescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.opcioncontrolvariablescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='Otro' value={opcioncontrolvariables} onChange={e => setopcioncontrolvariables(e.target.value)} disabled={!otrocontrolvariables} />
                                        <br></br> <span className='text-danger'>{anexoUnidadAlmacenMap?.opcioncontrolvariables}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={opcioncontrolvariablescheck} onChange={e => checkopcioncontrolvariablescheck()} checked={opcioncontrolvariablescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="number" className={`form-control ${anexoUnidadAlmacenMap.cantidadcontrolvariablescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.cantidadcontrolvariablescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='cantidad' value={cantidadcontrolvariables} onChange={e => setcantidadcontrolvariables(e.target.valueAsNumber)} disabled={!otrocontrolvariables} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.cantidadcontrolvariables}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={cantidadcontrolvariablescheck} onChange={e => checkcantidadcontrolvariablescheck()} checked={cantidadcontrolvariablescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="text" className={`form-control ${anexoUnidadAlmacenMap.caracteristicascontrolvariablescheck !== undefined ? (
                                            anexoUnidadAlmacenMap?.caracteristicascontrolvariablescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="" placeholder='caracteristicas' value={caracteristicascontrolvariables} onChange={e => setcaracteristicascontrolvariables(e.target.value)} disabled={!otrocontrolvariables} />
                                        <br></br><span className='text-danger'>{anexoUnidadAlmacenMap?.caracteristicascontrolvariables}</span><br></br>
                                        <input className="form-check-input" type="checkbox"
                                            value={caracteristicascontrolvariablescheck} onChange={e => checkcaracteristicascontrolvariablescheck()} checked={caracteristicascontrolvariablescheck} />
                                        <FontAwesomeIcon icon={faEye} /> Hacer una observación
                                    </div>
                                </div>
                                <div className=" text-align: justify">
                                    <br />
                                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center ${estilos.labelNaranja}`}>
                                        <h6 className='text-center'>DECLARACIONES Y CONSIDERACIONES</h6>
                                    </div>
                                    <div align="justify">
                                        <label className="floatingInput"><b>EL CLIENTE DECLARA BAJO PROTESTA DE DECIR VERDAD:</b></label>
                                        <br />
                                        <ol type="a">
                                            <li>Que los datos contenidos en la presente solicitud son ciertos y,</li>
                                            <li>Que ha leído y comprendido el contenido completo de los
                                                documentos: "Manual básico para inscripción y certificación ante COMERCAM (DC-02)", "Descripción
                                                de la información comercial (DC-07)", "Esquema de evaluación de la conformidad (DC-01)",
                                                "Uso     adecuado del sello de certificación, marca e imagen corporativa del COMERCAM (DC-06)",
                                                "Procedimiento de producto certificado (P-PC)" vigentes, la ley de Infraestructura de la Calidad
                                                (LIC) artículo 56 fracción I,II y III, artículo 60 fracción I, III, IV y la "NOM-070-SCFI-2016,
                                                Bebidas Alcohólicas-Mezcal Especificaciones", vigente.</li>
                                        </ol>
                                        <label className="floatingInput"><b>LA EMPRESA ATRAVEZ DE SU REPRESENTANTE LEGAL Y AUTORIZADO SE COMPROMETE A CUMPLIR CON:</b></label>
                                        <br />
                                        <ol align="justify" type="a">

                                            <li>La Norma Oficial Mexicana  NOM-070-SCFI-2016 “Bebidas Alcohólicas-Mezcal Especificaciones”,
                                                en vigor y los Criterios Autorizados por la Dirección General de Normas (DGN) </li>
                                            <li>Lo establecido en  el "Esquema de evaluación de la conformidad (DC-01)" , "Uso adecuado de la contraseña oficial NOM
                                                (DC-05)",  " Uso adecuado del sello de certificación, marca e imagen corporativa del COMERCAM (DC-06)", "Procedimiento
                                                de producto certificado (P-PC)".</li>
                                            <li>Cubrir las tarifas correspondientes al servicio solicitado y los gastos por  concepto de viáticos de los inspectores
                                                asignados para el proceso.</li>
                                        </ol>
                                        <p>
                                            <b>CONSIDERACIONES:</b>Este formato es de distribución gratuita. Se autoriza su libre reproducción, siempre y cuando éste no sea
                                            alterado y sea presentado impreso en una hoja de papel blanco, tamaño carta, completamente requisitada, firmada y rubricada
                                            por el representante autorizado o legal de forma autógrafa.
                                        </p>
                                        <br />
                                        <br />
                                        <div className="d-grid gap-2 col-6 mx-auto">

                                            <div className="text-center">
                                                <button type="submit"
                                                    onClick={botonAceptar} className={`btn ${estilos.botonNaranjaRedondo}`} >Aceptar observaciones</button>
                                            </div>
                                            {modalComponentAceptar()}
                                            <br />
                                        </div>
                                    </div>

                                </div>

                            </Fragment>
                        )
                }
                {modalComponentObservaciones(campoParaObservacion)}
                <div className='row ms-5 text-center mt-5'>
                    <ToolBarPaginas componente='fc_36Almacen' paginas={paginas} />
                </div>

            </div>
        </Fragment>
    )
}

export default withRouter(FC_36AnexoAlmacenComponent)
